import { moduleNamespace } from '../redux/store.config';

export const addNamespace = (action: string): string =>
	moduleNamespace + '/' + action;
